import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/analisis-estrategico',
  alias: [
    '/sistema/reportesbi/analisis-estrategico/Index',
    '/sistema/reportesbi/AnalisisEstrategico',
    '/sistema/reportesbi/AnalisisEstrategico/Index',
  ],
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['120'],
  cita: 'Areas/ReportesBI/Controllers/AnalisisEstrategicoController.cs',
} satisfies RutaProd;
